<template>
  <!-- content start -->
  <div
    :style="{
      backgroundImage: `url(${mainBackgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }"
  >
    <div class="layout-wrapper" style="width: 100%; height: 90vh">
      <!-- -------------------- FIXED HEADER -------------------- -->
      <div class="fixed-header" style="">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
          "
        >
          <h3
            style="color: #000000; margin: 0px; font-weight: bold; font-size: 16px"
          >
            Poll
          </h3>
        </div>
        <div>
          <img
            v-on:click="handleBack()"
            src="@/assets/Close-1.png"
            style="width: 22px; height: 22px; cursor: pointer"
            alt=""
          />
        </div>
      </div>
      <div class="poll-scroll">
        <!-- Poll Content Start Here -->
        <div
          :style="{
            backgroundImage: `url(${backgroundImage})`,
            color: isTitleColour
          }"
          class="poll-inner-div"
        >
          <div>
            <p
              style="
                  margin: 0;
                  font-size: 14px;
                  font-weight: 600;
                  padding: 10px 0px;
                  text-align: left;
                "
            >
              {{ game_data.ps_questions[0].title }}
            </p>
            <!-- Text Based Options -->
            <div c v-if="game_data.ps_questions[0].option_type === 'text'">
              <div
                v-for="(option, index) in game_data.ps_questions[0].options"
                :key="option.id"
              >
                <div
                  :style="{
                    border:
                      selectedOptionId === option.id
                        ? '2px solid' + isSelectedColour
                        : '1px solid #ccc',
                    color: isTitleColour,
                    padding: game_data.already_responed ? '12px' : '5px 10px'
                  }"
                  @click="selectOption(option.id)"
                  class="text-based-options"
                >
                  <div
                    v-if="game_data.already_responed"
                    style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                  >
                    <p
                      style="
                          margin: 0px !important;
                          font-size: 12px;
                          text-align: left;
                          width: 70%;
                        "
                    >
                      {{ option.title }}
                    </p>
                    <p
                      style="
                          margin: 0px !important;
                          font-size: 14px;
                          font-weight: bold;
                        "
                    >
                      {{ option.percentage }}%
                    </p>
                  </div>

                  <!-- 📊 Progress Bar -->
                  <div
                    v-if="game_data.already_responed"
                    style="
                        margin-top: 5px;
                        background-color: rgb(197 194 194);
                        height: 5px;
                        border-radius: 4px;
                      "
                  >
                    <div
                      :style="{
                        width: option.percentage + '%',
                        backgroundColor: 'black',
                        height: '100%',
                        borderRadius: '4px'
                      }"
                    ></div>
                  </div>

                  <p
                    v-else
                    :style="{
                      color: isTitleColour,
                      fontSize: '12px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      textAlign: 'left',
                      margin: '0px',
                      padding: '10px',
                      // wordWrap: 'break-word'
                      overflowWrap: 'break-word'
                    }"
                  >
                    {{ option.title }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Image Based Option -->
            <div v-else class="img-based-main">
              <div
                class="img-based-div"
                v-for="(option, index) in game_data.ps_questions[0].options"
                :key="option.id"
                :style="{
                  backgroundColor:
                    selectedOptionId === option.id ? '#ffffff' : '#ffffff',
                  borderRadius: '15px',
                  // border: selectedOptionId === option.id ?  '2px solid ' + $store.state.bg_theme  : '1px solid #ccc'
                  border:
                    selectedOptionId === option.id
                      ? '2px solid' + isSelectedColour
                      : '1px solid #ccc',
                  color: isTitleColour
                }"
                @click="selectOption(option.id)"
              >
                <div
                  style="
                      display: flex;
                      justify-content: center;
                      align-items: start;
                    "
                >
                  <p
                    v-if="game_data.already_responed"
                    class="img-already-reponded"
                  >
                    {{ option.percentage }}%
                  </p>
                  <img
                    v-else
                    :src="option.option_image_url"
                    alt="option.title"
                    class="image-size-question"
                  />
                </div>
                <p class="image-based-option-text">
                  {{ option.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Share & Deeplink Button -->
        <div
          v-if="game_data.already_responed"
          :style="{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 0px',
            width: '100%',
            marginTop: '10px',
            gap: '10px'
          }"
        >
          <button
            v-if="
              game_data.enable_share_link &&
                game_data.share_link_button_text !== ''
            "
            @click="handleShareClick"
            :style="{
              backgroundColor: isButtonColour || '#c7222a',
              color: isButtonTextColour || '#ffffff'
            }"
            class="btn-padding"
          >
            {{ game_data.share_link_button_text }}
          </button>

          <button
            class="btn-padding"
            v-if="game_data.enable_deeplink && game_data.deeplink_button_text"
            @click="handleDeeplinkClick"
            :style="{
              backgroundColor: isButtonColour || '#c7222a',
              color: isButtonTextColour || '#ffffff'
            }"
          >
            {{ game_data.deeplink_button_text }}
          </button>
        </div>
      </div>
    </div>
    <!-- Share Popup -->
    <div
      v-if="showSharePopup"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      "
    >
      <div
        style="
          position: relative;
          width: 100%;
          max-width: 400px;
          background: white;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
          text-align: center;
          padding: 20px 0px;
        "
      >
        <!-- Go Back Button (centered above popup) -->
        <button
          @click="showSharePopup = false"
          :style="{
            position: 'absolute',
            top: '-55px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'white',
            color: bgTheme,
            border: 'none',
            borderRadius: '50px',
            padding: '11px 16px',
            fontSize: '14px',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            fontWeight: '700',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px'
          }"
        >
          <!-- Chevron Left Icon -->
          <div
            :style="{
              width: '16px',
              height: '16px',
              backgroundColor: bgTheme, // dynamic button color
              WebkitMaskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain'
            }"
          ></div>
          Go back
        </button>

        <p style="font-weight: bold; margin: 10px 0">Share via</p>

        <!-- Share Options -->
        <div
          style="display: flex; justify-content: space-evenly; margin-top: 15px"
        >
          <!-- Facebook -->
          <div
            @click="shareContent('whatsapp', game_data.share_link_text)"
            style="cursor: pointer"
          >
            <!-- <img :src="offerData.share_options[0].icon" alt="Facebook" style="width: 40px; height: 40px;" /> -->
            <img
              style="
                cursor: pointer;
                width: 35px;
                height: 35px;
                margin-bottom: 5px;
              "
              src="@/assets/whatsapp.png"
              alt="back"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px">WhatsApp</p>
          </div>
          <!-- Twitter -->
          <div
            @click="shareContent('facebook', game_data.share_text)"
            style="cursor: pointer"
          >
            <!-- <img :src="offerData.share_options[1].icon" alt="Twitter" style="width: 40px; height: 40px;" /> -->
            <img
              style="
                cursor: pointer;
                width: 35px;
                height: 35px;
                margin-bottom: 5px;
              "
              src="@/assets/facebook.png"
              alt="back"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px">Facebook</p>
          </div>
          <!-- Gmail -->
          <div
            @click="shareContent('instagram', game_data.share_text)"
            style="cursor: pointer"
          >
            <!-- <img :src="offerData.share_options[2].icon" alt="Gmail" style="width: 40px; height: 40px;" /> -->
            <img
              style="
                cursor: pointer;
                width: 35px;
                height: 35px;
                margin-bottom: 5px;
              "
              src="@/assets/instagram.png"
              alt="back"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px">Instagram</p>
          </div>

          <div @click="copyShareLink" style="text-align: center">
            <div
              :style="{
                width: '40px',
                height: '40px',
                margin: 'auto',
                backgroundColor: bgTheme, // Background color
                // backgroundColor: 'red',
                borderRadius: '50%', // Make it circular
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: '5px'
              }"
            >
              <div
                :style="{
                  width: '20px', // Icon size
                  height: '20px',
                  backgroundColor: 'white', // Icon color
                  WebkitMaskImage:
                    'url(' + asset('copy-img1.png') + ')',
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: 'url(' + asset('copy-img1.png') + ')',
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain'
                }"
              ></div>
            </div>

            <p
              style="margin: 0px !important; font-size: 12px; font-weight: bold"
            >
              Copy link
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast message -->
    <div
      id="copied-toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="
        width: 100px;
        padding: 5px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.3);
        margin-bottom: 70px;
        color: white;
        display: none;
        bottom: 10%;
      "
    >
      Link Copied
    </div>

    <!-- Footer Logo -->
    <div class="fixed-footer" v-if="isLogoVisible" style="padding-bottom: 20px">
      <img
        class="abcd-logo"
        :src="logoUrl"
        alt=""
        @error="isLogoVisible = false"
      />
    </div>
  </div>
</template>

<script>
import { asset } from "@/utils/asset";
import { navigateDeeplink } from "@/utils/deeplink";
// import Tasks from '../components/Tasks'
import QuizHeader from "@/components/quiz-header";
import PollHeader from "@/components/poll-header";
import axios from "axios";
import backgroundImage from "@/assets/back_frame_png.png";
import mainBackgroundImage from "@/assets/back_image_poll.png";
import { globals } from "@/mixins/globals";
import { height } from "@fortawesome/free-regular-svg-icons/faAddressBook";
export default {
  name: "quiz-details-custom",
  mixins: [globals],
  props: {
    date: {
      type: String
    }
  },
  components: {
    QuizHeader,
    PollHeader
  },
  data: () => ({
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    id: "",
    game_data: "",
    show_detail: true,
    endTime: null,
    valchangeCall: null,
    selectedOptionId: null,
    pollId: null, // <== track the already selected option
    backgroundImage,
    mainBackgroundImage,
    isLogoVisible: false,
    logoUrl: "",
    timer: () => {},
    isSelectedColour: "",
    isTitleColour: "",
    showSharePopup: false,
    isButtonColour: "",
    isButtonTextColour: ""
  }),
  computed: {
    showOnlyOneButton() {
      const showShare =
        this.game_data.enable_share_link &&
        this.game_data.share_link_button_text !== "";
      const showDeeplink =
        this.game_data.enable_deeplink && this.game_data.deeplink_button_text;
      return (showShare && !showDeeplink) || (!showShare && showDeeplink);
    },
    bg_theme() {
      return this.$store.state.bg_theme;
    },
    sdkEvent() {
      return this.$store.state.sdkEvent;
    },
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
    is_live() {
      let d1 = new Date();
      let d2 = new Date(this.game_data.starts_at);
      let diff = d2 - d1;
      if (diff === 0) {
        this.game_data.is_live = true;
      }
      return this.game_data.is_live;
    }
  },

  mounted() {
    this.isSelectedColour = this.sdkEvent.isSelectedColour;
    this.isTitleColour = this.sdkEvent.isTitleColour;
    this.isButtonColour = this.sdkEvent.isButtonColour;
    this.isButtonTextColour = this.sdkEvent.isButtonTextColour;

    if (this.sdkEvent.logoUrl) {
      this.isLogoVisible = true;
      this.logoUrl = this.sdkEvent.logoUrl;
    } else {
      this.isLogoVisible = false;
    }
  },
  methods: {
    shareContent(platform, shareText) {
      const encodedText = encodeURIComponent(shareText);

      switch (platform) {
        case "whatsapp":
          window.open(`https://wa.me/?text=${encodedText}`, "_blank");
          break;

        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodedText}`,
            "_blank"
          );
          break;

        case "instagram":
          // Instagram does not support direct text-sharing in browser
          // So we copy text + open Instagram
          navigator.clipboard.writeText(shareText);
          alert("Text copied! Paste it in Instagram.");
          window.open("https://instagram.com/", "_blank");
          break;

        case "twitter":
          window.open(
            `https://twitter.com/intent/tweet?text=${encodedText}`,
            "_blank"
          );
          break;

        default:
          console.warn("Unknown platform");
      }
    },
    copyShareLink() {
      const fullText = this.game_data.share_link_text;

      if (fullText) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(fullText)
            .then(() => {
              this.showCopiedToast();
              this.showSharePopup = false;
            })
            .catch(err => {
              console.warn("Clipboard API failed:", err);
              this.fallbackCopyText(fullText);
            });
        } else {
          this.fallbackCopyText(fullText);
        }
      } else {
        console.warn("No share text found to copy.");
      }
    },

    fallbackCopyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopiedToast();
          this.showSharePopup = false;
        }
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textarea);
    },

    showCopiedToast() {
      const toast = document.getElementById("copied-toast");
      if (toast) {
        toast.style.display = "block";
        setTimeout(() => {
          toast.style.display = "none";
        }, 2000); // Hide after 2 seconds
      }
    },
    handleShareClick() {
      const text = this.game_data.share_link_text;
      const urlMatch = text.match(/https?:\/\/[^\s]+/);
      if (urlMatch) {
        // window.open(urlMatch[0], '_blank');
        this.showSharePopup = !this.showSharePopup;
      } else {
        this.showSharePopup = !this.showSharePopup;
        console.warn("No valid share URL found in share_link_text");
      }
    },
    handleDeeplinkClick() {
      navigateDeeplink(this.$router, this.game_data.deeplink_text);
    },

    sharemessage(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      document.getElementById("toast").style.width = "100px";
      document.getElementById("toast").innerHTML = "Copied";
      document.getElementById("toast").style.display = "block";
      setTimeout(function() {
        document.getElementById("toast").style.width = 80 + "%";
        document.getElementById("toast").style.display = "none";
      }, 2000);
    },
    notifyUser() {
      var self = this;
      var url =
        self.$store.getters.flyyDomain +
        "/v1/notify_user/" +
        self.id +
        "?notify_type=API";
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            // console.log(data)
            this.game_data.notified = true;

            document
              .getElementsByTagName("footer")[0]
              .getElementsByTagName(
                "div"
              )[0].innerHTML = `<div class="" style="margin-right: 15px; margin-left: 15px;"><div style="color: #fff; padding: 8px 0; background: grey !important; width: 150px; margin: auto; border-radius: 50px;">Play Quiz Now</div></div>`;
            document.getElementById("toast").innerHTML = data.message;
            document.getElementById("toast").style.display = "block";
            setTimeout(function() {
              document.getElementById("toast").style.display = "none";
            }, 2000);
          } else {
            console.log("Error Notifying User");
          }
        });
    },
    handleDeeplink(deeplink) {
      // deeplink = "https://www.google.com"
      if (deeplink) {
        window.open(deeplink, "_blank");
      }
    },
    timeUpdate() {
      if (this.distance < 0) {
        clearInterval(this.timer);
        return;
      }
      const seconds = parseInt(
        Math.floor(this.distance % this._minutes) / this._seconds
      );
      const minutes = parseInt(
        Math.floor(this.distance % this._hours) / this._minutes
      );
      const days = parseInt(Math.floor(this.distance / this._days));
      const hours = parseInt(
        Math.floor(this.distance % this._days) / this._hours
      );

      this.displayMinutes = minutes < 10 ? "0" + minutes : minutes;
      this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
      this.displayHours = hours < 10 ? "0" + hours : hours;
      this.displayDays = days < 10 ? "0" + days : days;
      this.distance = this.distance - 1000;
    },
    showRemaining(onChange) {
      if (onChange) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (this.distance < 0) {
          clearInterval(this.timer);

          return;
        }
        const seconds = parseInt(
          Math.floor(this.distance % this._minutes) / this._seconds
        );
        const minutes = parseInt(
          Math.floor(this.distance % this._hours) / this._minutes
        );
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(
          Math.floor(this.distance % this._days) / this._hours
        );

        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes;
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds;
        this.displayHours = hours < 10 ? "0" + hours : hours;
        this.displayDays = days < 10 ? "0" + days : days;
        this.distance = this.distance - 1000;
      }, 1000);
    },
    getTotalPoolPrize() {
      let poolprize = 0;
      this.game_data.prizes.forEach(i => {
        let people = 0;
        if (i.from_rank === i.to_rank) {
          people = 1;
        } else {
          people = i.to_rank - i.from_rank + 1;
        }
        poolprize += people * i.to_prize;
      });
      return poolprize;
    },
    fetchQuizDetails(valChangeCall) {
      var self = this;
      this.pollId = self.id;
      console.log("Self - ", self.id);
      this.valchangeCall = valChangeCall;
      var url =
        self.$store.getters.flyyDomain + "/v1/start_poll_survey/" + self.id;
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            console.log({ data });
            self.game_data = data;
            if (data.already_responed && data.responses.length > 0) {
              self.selectedOptionId = data.responses[0].selected_option;
            }

            console.log(self.game_data);
            this.$store.state.quizDetailsTitle = self.game_data.title;
            var now = new Date();
            var end = new Date(self.game_data.starts_at);

            if (self.game_data.is_live) {
              now = new Date();
              end = new Date(self.game_data.ends_at);
            }
            self.endTime = end;
            self.distance = end - now;
            self.showRemaining(valChangeCall);
          } else {
            console.log("Error fetching the Quiz Details");
          }
        });
    },
    showDetails() {
      this.show_detail = true;
    },
    showLeaderBoard() {
      this.show_detail = false;
    },
    handleBack() {
      var currentUrl = window.location.pathname;
      if (currentUrl == "/play-quiz") {
        this.$store.state.showExitModal = true;
        return;
      }
      this.$router.go(-1);
    },

    selectOption(optionId) {
      if (this.game_data.already_responed) return; // Prevent re-submitting

      this.selectedOptionId = optionId;

      const questions = this.game_data.ps_questions;
      const question = questions && questions.length > 0 ? questions[0] : null;
      const selectedOption =
        question && question.options
          ? question.options.find(opt => opt.id === optionId)
          : null;

      if (!question || !selectedOption) {
        console.error("Missing question or selected option");
        return;
      }

      console.log("Game Data - ", this.game_data);
      console.log("Poll ID : ", this.pollId);

      const url =
        this.$store.getters.flyyDomain + "/v1/save_poll_survey/" + this.pollId;
      const headers = this.$store.getters.headers;

      const payload = {
        responses: [
          {
            question_id: question.id,
            selected_option: selectedOption.id
          }
        ]
      };

      axios
        .post(url, payload, { headers })
        .then(response => {
          if (response.status === 200) {
            // Mark user as responded
            this.game_data.already_responed = true;

            // Save selected response
            this.game_data.responses = response.data.responses;

            // Update full question data (including updated percentages)
            if (Array.isArray(response.data.ps_questions)) {
              this.game_data.ps_questions = response.data.ps_questions;
            }

            // Update selected option ID visually
            const selectedResp =
              response.data.responses && response.data.responses[0];
            if (selectedResp) {
              this.selectedOptionId = selectedResp.selected_option;
            }

            console.log("Poll response submitted successfully");
          }
        })
        .catch(error => {
          console.error("Error submitting poll response", error);
        });
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId;
    this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails(false);
  },
  watch: {
    distance: function(val) {
      if (val <= 0 && !this.valchangeCall) {
        this.fetchQuizDetails(true);
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.layout-wrapper {
  position: relative;
  /* height: 85vh; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fixed-footer {
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/* Default for most mobiles */
.card {
  height: 180px;
}

/* -------- Base styles: apply at every width (tablet/desktop included).
   The media queries below only tighten these for small phones. -------- */
.fixed-header {
  margin: 15px;
  margin-top: 0px;
  margin-bottom: 20px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 999;
}

.poll-scroll {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
}

.poll-inner-div {
  background-size: cover;
  padding: 20px;
  border-radius: 12px;
  max-height: 67vh;
  overflow-y: auto;
}

.text-based-options {
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 15px;
  cursor: pointer;
  overflow-wrap: break-word;
  word-break: break-word;
}

.btn-padding {
  padding: 15px 10px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}

.img-based-main {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  align-items: stretch;
}

.img-based-div {
  padding: 14px 10px;
  margin-top: 10px;
  border-radius: 15px;
  width: calc(50% - 4px);
  cursor: pointer;
  /* min-height, not height: option labels wrap to 2-3 lines and used to
     spill out of the card. */
  min-height: 100px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.image-size-question {
  width: 100%;
  max-height: 70px;
  object-fit: contain;
  border-radius: 5px;
}

.image-based-option-text {
  margin: 0;
  margin-top: 8px !important;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  line-height: 1.3;
  overflow-wrap: break-word;
  word-break: break-word;
}

.img-already-reponded {
  margin: 8px 0px 5px 0px !important;
  font-size: 20px;
}

.abcd-logo {
  width: 60px;
  height: 60px;
  margin-top: 20px;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .fixed-header {
    margin: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-top: 20px;
    margin-top: 0px;
    position: sticky;
    top: 0;
    z-index: 999;
  }

  .poll-scroll {
    /* max-height: 70vh; */
    overflow-y: auto;
    padding-right: 5px;
    scrollbar-width: thin;
    padding: 20px 20px 0px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* background-color: aliceblue; */
  }

  .text-based-options {
    background-color: #ffffff;
    /* padding: 5px 10px; */
    margin-top: 10px;
    border-radius: 15px;
    cursor: pointer;
  }

  .poll-inner-div {
    background-size: cover;
    padding: 20px;
    border-radius: 12px;
    /* height: 100%; */
    overflow-y: auto;
  }

  .btn-padding {
    padding: 12px 10px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    /* text-transform: uppercase; */
  }

  .img-based-main {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: space-between;
  }

  .img-based-div {
    padding: 14px 8px;
    margin-top: 10px;
    border-radius: 15px;
    width: calc(50% - 4px);
    cursor: pointer;
    min-height: 70px;
    height: auto;
  }

  .image-size-question {
    object-fit: contain;
    border-radius: 5px;
    max-height: 50px;
  }

  .image-based-option-text {
    margin: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 6px !important;
    font-weight: 600;
  }

  .img-already-reponded {
    margin: 12px 0px 5px 0px !important;
    font-size: 18px;
  }
  .abcd-logo {
    width: 45px;
    height: 45px;
    margin-top: 20px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .abcd-logo {
    width: 60px;
    height: 60px;
    margin-top: 20px;
  }
  .img-already-reponded {
    margin: 25px 0px 5px 0px !important;
    font-size: 20px;
  }
  .img-based-main {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: space-between;
  }

  .img-based-div {
    padding: 14px 10px;
    margin-top: 10px;
    border-radius: 15px;
    width: calc(50% - 4px);
    cursor: pointer;
    min-height: 100px;
    height: auto;
  }

  .image-size-question {
    object-fit: contain;
    border-radius: 5px;
    max-height: 70px;
  }

  .image-based-option-text {
    margin: 0;
    text-align: center;
    margin-top: 10px !important;
    font-size: 15px;
    font-weight: 500;
  }

  .btn-padding {
    padding: 15px 10px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    /* text-transform: uppercase; */
  }

  .poll-inner-div {
    background-size: cover;
    padding: 20px;
    border-radius: 12px;
    max-height: 67vh;
    overflow-y: auto;
  }

  .text-based-options {
    background-color: #ffffff;
    /* padding: 15px; */
    margin-top: 10px;
    border-radius: 15px;
    cursor: pointer;
  }

  .poll-scroll {
    padding: 20px;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .fixed-header {
    margin: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-top: 20px;
    margin-top: 0px;
    position: sticky;
    top: 0;
    z-index: 999;
  }
}
</style>
